const tr = {
  whatsappCampaign: {
    attributes: {
      template_name: 'Nome do template (Infobip)',
      template_language: 'Idioma do template',
      header_video_url: 'URL do vídeo do template',
      send_hours: 'Horários de envio',
      batch_size: 'Convites por rodada',
      min_days_since_signup: 'Dias mínimos de cadastro',
      is_enabled: 'Envio automático',
      last_tick_at: 'Último sinal do relógio',
      last_run_at: 'Última execução',
    },
    extras: {
      statusTitle: 'Situação da campanha',
      resultsTitle: 'Resultados da campanha',
      audienceTitle: 'Público da campanha',
      templateTitle: 'Template da Infobip',
      scheduleTitle: 'Agendamento',
      funnelFilter: 'Filtro',
      funnelUsers: 'Usuários',
      sendHoursHelp: 'Horário de Brasília, separado por vírgula. Ex.: 8, 12, 17',
      batchHelp: 'Quantidade de envios em cada horário',
      minDaysHelp: 'Tempo mínimo de cadastro para receber o convite',
      enabledHelp: 'Desligado, só "Executar agora" e o convite manual enviam',
      invitations: 'Convites enviados',
      clockAlive: 'Relógio ativo (há {{minutes}} min)',
      clockDead: 'Relógio sem sinal há {{minutes}} min',
      clockNever: 'Relógio nunca rodou',
      autoOn: 'Envio automático ligado',
      autoOff: 'Envio automático desligado',
      sendBlocked: 'Envio bloqueado no servidor',
      neverRan: 'Nunca executou',
      runNow: 'Executar agora',
      runNowConfirm: 'Enviar uma rodada agora com a configuração salva?',
      runNoToken: 'Sem token da Infobip, nenhuma mensagem sai. Preencha o token em "Acesso à Infobip" e salve antes de executar.',
      runSendBlocked: 'O envio está bloqueado no servidor deste ambiente, nenhuma mensagem sai.',
      runRequested: 'Rodada solicitada. Sai em até 10 minutos.',
      runPending: 'Rodada solicitada',
      running: 'Rodada em andamento',
      previewHelp: 'Quantos usuários passam em cada filtro hoje.',
      resultsEmpty: 'Nenhum convite enviado até agora.',
      resultsEmptyTemplate: 'Nenhum convite enviado com este template.',
      resultsEmptyPeriod: 'Nenhum convite enviado neste período.',
      resultStage: 'Etapa',
      resultPeople: 'Pessoas',
      resultShare: '% dos convites',
      resultTemplate: 'Template',
      resultTemplateAll: 'Todos os templates',
      invite: 'Convidar agora',
      sentFrom: 'Enviado de',
      sentUntil: 'Enviado até',
      statusFilter: 'Situação',
      statusAll: 'Todas as situações',
      downloadPdf: 'Baixar PDF',
      pdfGenerating: 'Gerando o PDF com os filtros atuais...',
      pdfDone: 'PDF gerado.',
      pdfError: 'Não foi possível gerar o PDF.',
      inviteUser: 'Usuário',
      inviteUserRequired: 'Escolha o usuário',
      inviteSent: 'Convite enviado.',
      saved: 'Configuração salva.',
      summary: {
        trigger: 'Disparo',
        scanned: 'Avaliados',
        sent: 'Enviados',
        failed: 'Falhas',
        skipped: 'Pulados',
        stopped_reason: 'Parou por',
        error: 'Erro',
        manual: 'manual',
        schedule: 'agendado',
        batch_full: 'lote completo',
        exhausted: 'acabaram os elegíveis',
        timeout: 'tempo limite',
        rate_limited: 'limite da Infobip (429)',
        consecutive_failures: 'falhas seguidas',
        no_api_token: 'sem token da API',
        no_settings: 'tabela de configuração vazia',
        token_invalid: 'token não pôde ser lido (APP_KEY diferente?)',
        send_disabled: 'envio desligado',
      },
      results: {
        invited: 'Convites enviados',
        delivered: 'Entregues no WhatsApp',
        undeliverable: 'Não entregáveis',
        consented: 'Responderam Sim',
        declined: 'Responderam Não',
        awaiting_birth_month: 'Aguardando validação do mês de nascimento',
        awaiting_surname: 'Aguardando validação do sobrenome',
        awaiting_cpf_digits: 'Aguardando validação do CPF',
        validation_failed: 'Erraram a validação',
        already_active: 'Já tinham acesso',
        validated: 'Validaram e receberam a senha',
        entered_app: 'Entraram no app',
      },
      funnel: {
        never_accessed: 'Nunca acessaram o app (Chapecó)',
        old_enough: 'Cadastrados há tempo suficiente',
        valid_mobile: 'Com celular válido',
        valid_cpf_length: 'Com CPF de 11 dígitos',
        has_validation_data: 'Com nascimento ou sobrenome',
        already_invited: 'Já convidados',
        skipped: 'Pulados (aguardando reavaliação)',
        eligible_now: 'Elegíveis agora',
      },
      statuses: {
        sent: 'Enviado',
        delivered: 'Entregue',
        undeliverable: 'Não entregável',
        failed: 'Falhou',
        skipped: 'Pulado',
      },
      reasons: {
        landline: 'Telefone fixo',
        invalid_phone: 'Celular inválido',
        invalid_ddd: 'DDD inválido',
        foreign_prefix: 'Prefixo do país não é 55',
        send_error: 'Erro no envio, será tentado de novo',
        no_phone: 'Sem celular',
        invalid_cpf: 'CPF inválido',
        no_cpf: 'Sem CPF',
        duplicate_cpf: 'CPF repetido em outro cadastro',
        duplicate_phone: 'Celular repetido em outro cadastro',
        no_name: 'Sem nome',
        phone_blocked: 'Número pediu para parar ou já validou',
        phone_already_invited: 'Número já convidado por outro cadastro',
        user_not_found: 'Usuário não encontrado',
        not_customer: 'Não é paciente',
        deleted: 'Cadastro excluído',
        other_partner: 'Não é da empresa da campanha',
        already_accessed: 'Já entrou no app',
        already_invited: 'Já convidado',
        no_birth_date: 'Sem data de nascimento',
        no_surname: 'Sem data de nascimento nem sobrenome',
        skipped_recently: 'Avaliado há pouco, aguardando reavaliação',
        send_disabled: 'Envio desligado',
        no_api_token: 'Sem token da API',
        no_settings: 'Tabela de configuração vazia',
        token_invalid: 'Token não pôde ser lido',
      },
    },
    invitations: {
      attributes: {
        id: 'ID',
        user_id: 'Usuário',
        user_name: 'Nome',
        phone: 'Telefone',
        status: 'Situação',
        skip_reason: 'Motivo',
        error: 'Erro',
        sent_at: 'Enviado em',
        delivered_at: 'Entregue em',
        evaluated_at: 'Avaliado em',
      },
    },
    defSingular: 'Campanha de ativação',
    defPlural: 'Campanha de ativação',
  },
};

export default tr;
